/**
 * Important Safety Information footer functionality.
 *
 * @package  Firdapse HCP
 * @since    1.0.0
 */

/**
 * Import dependencies.
 */
const { html, body, header, footer } = embark.els;

class SafetyFooter {

	constructor(el) {
		if (el) {
			this.el = el;
			this.expandBtn = this.el.querySelector('#js-isi-view-sticky');
			this.isiBounds =  this.el.getBoundingClientRect();

			this.page = body.querySelector('main.site');
			this.pageBounds = this.page.getBoundingClientRect();

			this.expandBtn.addEventListener('click', this.handleExpandClick);
			document.addEventListener('scroll', this.handleScroll);

			// ISI is always open on the 404 page, and the form thank you pages.
			if (body.classList.contains('error404') || body.classList.contains('page-id-1846') || body.classList.contains('page-id-1837')) {
				this.el.classList.add('is-scrolled');
			}
		}
	}

	closeISI = () => {
		body.classList.remove('isi-open');
		this.el.classList.remove('is-expanded');
		this.el.style.top = '';
		this.el.style.bottom = '0px';
		footer.style.top = '';
		this.expandBtn.innerText = 'EXPAND';
	}

	openISI = () => {
		body.classList.add('isi-open');
		this.el.classList.add('is-expanded');
		this.el.style.top = (header.offsetHeight + header.offsetTop) + 'px';
		if (this.pageBounds.height < this.el.offsetHeight) {
			footer.style.top = (this.pageBounds.top + 25) + 'px';
		} else {
			footer.style.top = (this.el.offsetHeight + 25) + 'px';
		}
		this.expandBtn.innerText = 'COLLAPSE';
	}

	handleExpandClick = () => {
		if (this.el.classList.contains('is-expanded')) {
			this.closeISI();
		} else {
			this.openISI();
		}
	}

	handleScroll = () => {
		window.requestAnimationFrame(() => {
			// Get the current scroll position.
			this.scrollTop =  window.scrollY || html.scrollTop || body.scrollTop;

			if (this.scrollTop >= (this.page.offsetTop + this.pageBounds.bottom - window.innerHeight)) {
				this.el.classList.add('is-scrolled');
			} else {
				this.el.classList.remove('is-scrolled');
			}
		});
	}
}

const safetyFooter = document.getElementById('js-isi');

if (safetyFooter) {
	embark.components.isi = new SafetyFooter(safetyFooter);
}
